export const TRANSACTION_STATUS = Object.freeze({
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  ERROR: 'ERROR',
  VOIDED: 'VOIDED',
  PENDING: 'PENDING',
})

export const FINAL_STATUSES = [
  TRANSACTION_STATUS.APPROVED,
  TRANSACTION_STATUS.DECLINED,
  TRANSACTION_STATUS.ERROR,
  TRANSACTION_STATUS.VOIDED,
]

export const RETRY_STATUSES = [
  TRANSACTION_STATUS.DECLINED,
  TRANSACTION_STATUS.ERROR,
]

export const STATUS_TITLE_KEYS = {
  [TRANSACTION_STATUS.APPROVED]: 'summary.standardStatus.approved',
  [TRANSACTION_STATUS.DECLINED]: 'summary.standardStatus.declined',
  [TRANSACTION_STATUS.ERROR]: 'summary.standardStatus.error',
  [TRANSACTION_STATUS.VOIDED]: 'summary.standardStatus.voided',
  [TRANSACTION_STATUS.PENDING]: 'summary.standardStatus.pending',
}

export const DEFAULT_REDIRECT_URL = 'https://wompi.com'
